import cn from 'classnames';
import React from 'react';
import { IMortgageBankShort } from '../../types/mortgage/bank';
import { IMortgagePropertyRates } from '../../types/mortgage/data';
import { MainpageMortgageContainer } from './MainpageMortgageContainer';
import * as styles from './MortgageLanding.css';

export interface IMortgageLandingProps {
  loanTerm?: number;
  propertyAmount?: number;
  initialPayment?: number;
  pageType?: string;
  banks: IMortgageBankShort[];
  rates: IMortgagePropertyRates;
}

export const MortgageLanding = (props: IMortgageLandingProps) => {
  return (
    <div className={styles.wrapper}>
      <div className={cn('cg-container-fluid-xs', styles.root)}>
        <MainpageMortgageContainer rates={props.rates} />
      </div>
    </div>
  );
};
